import { EInternalNoteType } from '@constants';
import { useTranslation } from 'react-i18next';

import { EIconType, Icon } from '../../Icon';

import { StyledTag, TextWrapper } from './InternalNoteTypeTag.styles';
import { getInternalNoteTypeTagStyles } from './utils';

type Props = {
  type: EInternalNoteType;
  icon?: EIconType;
  onClick?: () => void;
};

export const InternalNoteTypeTag: React.FC<Props> = ({ type, icon, onClick }) => {
  const { t } = useTranslation();
  const { textColor, backgroundColor, borderColor } = getInternalNoteTypeTagStyles(type);

  return (
    <StyledTag bordercolor={borderColor} bgcolor={backgroundColor} onClick={onClick}>
      <TextWrapper textcolor={textColor}>{t(type)}</TextWrapper>
      {icon && <Icon i={icon} />}
    </StyledTag>
  );
};
